import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux';
import { Container } from 'inversify';
import { API_LANGUAGE_MODAL_LOAD_LIST_URL, API_LANGUAGE_MODAL_NAME } from '#baseLanguageModal/constants';
import { LoadListResponseType } from '#baseLanguageModal/api';

const getApiLanguageModal = (diContainer: Container) => createApi({
  reducerPath: API_LANGUAGE_MODAL_NAME,
  baseQuery: getBaseQuery(diContainer),
  endpoints: (builder) => ({
    loadList: builder.query<LoadListResponseType, string>({
      query: (slug: string) => ({
        url: API_LANGUAGE_MODAL_LOAD_LIST_URL,
        params: {
          slug,
        },
      }),
    }),
  }),
});

export { getApiLanguageModal };
